import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Mixins / Modules
import isResizable from '../../../../../mixins/resizable';

// Base
import Card from '../../../../base/card';

// Related Components
import ShowLoading from './show/loading';

class _Loading extends React.Component {
  static propTypes = {
    isMobile: PropTypes.bool.isRequired,
  }

  render() {
    const { isMobile } = this.props;
    return (
      <div className='full-width-content'>
        <Card
          className={classNames('width-auto', {
            'min-height-180': !isMobile,
            'min-height-370': isMobile,
          })}
          border='thin'
        >
          <ShowLoading />
        </Card>
      </div>
    )
  }
}

export default isResizable(_Loading);